(function($) {
    $.widget("ca.caAutolistInput", {
        _create : function() {
            var is_button_pressed = false;

            // Hide original input
            var curr_id = $(this.element).attr('id');
            $('#' + curr_id).hide();

            // Get initial value
            var control_options = $('<ul class="autolist-input-data"></ul>');
            var value_set = $('#' + curr_id).val().split(',');

            // Create control options
            if (value_set.length > 0) {
                for (var i = 0; i < value_set.length; i++) {
                    if (value_set[i] != '') {
                        control_options.append('<li rel="' + value_set[i] + '">' + value_set[i] + ' <span class="autolist-input-remove del"></span></li>');
                    } else {
                        value_set.splice(i, 1);
                    }
                }
            }

            // Update value
            $('#' + curr_id).val(value_set.join(','));

            // Insert new control markup
            $('#' + curr_id).after(
                '<div class="autolist-input-control" rel="' + curr_id + '">' +
                    '<div class="autolist-input-input-wrap">' +
                        '<input type="button" class="autolist-input-add" value=" " />' +
                        '<input type="text" class="autolist-input-input" />' +
                    '</div>' +
                    control_options[0].outerHTML +
                '</div>'
            );

            $('.autolist-input-input').bind('keypress', function(event) {
                var is_value_approved = false;

                // Work only onEnter event
                if (event.which == 13 || is_button_pressed) {
                    // Prevent form auto submit
                    event.preventDefault();

                    var value = $(this).val();
                    $(this).val('');
                    var curr_id = $(this).closest('div.autolist-input-control').attr('rel');

                    // Get original value
                    var value_set = $('#' + curr_id).val();

                    // Check if empty
                    if (value_set == '') value_set = [];
                    else value_set = value_set.split(',');

                    // Check exists and not empty values
                    if (value != '' && value_set.indexOf(value) == -1) {
                        is_value_approved = true;
                        value_set.push(value);
                    }

                    // Update original input value and html list
                    $('#' + curr_id).val(value_set.join(','));
                    if (is_value_approved) {
                        $(this).closest('div.autolist-input-control').children('.autolist-input-data').append(
                            '<li rel="' + value + '">' + value + ' <span class="autolist-input-remove del"></span></li>'
                        );
                    }

                    // Prevent form auto submit
                    return is_button_pressed = false;
                }
            });

            $('.autolist-input-add').bind('click', function() {
                is_button_pressed = true;
                $(this).next('.autolist-input-input').keypress();
            });

            $('.autolist-input-data').delegate('.autolist-input-remove', 'click', function() {
                var value = $(this).parent('li').attr('rel');
                var curr_id = $(this).closest('div.autolist-input-control').attr('rel');
                var value_set = $('#' + curr_id).val().split(',');

                // Remove value if exists
                for (var i = 0; i < value_set.length; i++) {
                    if (value_set[i] == value) {
                        value_set.splice(i, 1);
                        $('#' + curr_id).val(value_set.join(','));
                    }
                }

                // Remove control data item
                $(this).parent('li').remove();
            });
        }
    });
})(jQuery);
